/* eslint-disable import/no-cycle */
import ajax from '../../../scanline/utils/ajax';

export default (url, data, method, callback, isAnonymous, aip = 'admin') => {
	return ajax(url, data, method, callback, isAnonymous, aip);
};
